export enum StoreStatus {
  Idle = 'Idle',
  Loading = 'Loading',
  Failed = 'Failed',
  Succeeded = 'Succeeded',
  CompletedPassword = 'CompletedPassword',
  CompletedResetPassword = 'CompletedResetPassword',
}
